import React, {useEffect, useRef, useState} from 'react';
import {useGlobal} from "reactn";
import { Scene } from '@soulmachines/smwebsdk';
import config from "../../config";
import "./SoulMachine.sass"


const SoulMachine = () => {
    const videoRef = useRef(null);
    const sceneRef = useRef(null);

    const setSoulMachineScene = useGlobal('soulMachineScene')[1];

    useEffect(() => {
        const init = async () => {
            const scene = new Scene({
                videoElement: videoRef.current,
                requestedMediaDevices: {},
                requiredMediaDevices: {},
                apiKey: config.SOULMACHINE_API_KEY,
            });
            
            sceneRef.current = scene;
            setSoulMachineScene(scene);
            await scene.connect();
            await scene.startVideo();
        };
        init().catch(console.error);

    }, []);

    return (
        <video ref={videoRef} className="soul-machine" autoPlay />
    );
}

export default SoulMachine;
